/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Tag configuration for StackAdapt creative
*/
export class V3StackAdaptCreativeTag {
    /**
    * JavaScript code for the tag
    */
    'jsCode'?: string;
    /**
    * Height of the tag
    */
    'height'?: number;
    /**
    * Width of the tag
    */
    'width'?: number;
    /**
    * Whether the tag is expandable
    */
    'isExpandable'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "jsCode",
            "baseName": "jsCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "height",
            "baseName": "height",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "width",
            "baseName": "width",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "isExpandable",
            "baseName": "isExpandable",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreativeTag.attributeTypeMap;
    }

    public constructor() {
    }
}

